export const blobMap = new Map<string, Blob>();
export const urlMap = new Map<string, string>();
export const refMap = new Map<string, number>();

export function getImageBlob(guid: string): Blob | undefined {
    return blobMap.get(guid);
}

export function putImageBlob(fileName: string, blob: Blob) {
    blobMap.set(fileName, blob);
    if (!urlMap.has(fileName)) {
        urlMap.set(fileName, URL.createObjectURL(blob));
    }
}

export function getImageUrl(guid: string): string | undefined {
    return urlMap.get(guid);
}

export function addImageRef(guid: string) {
    refMap.set(guid, (refMap.get(guid) ?? 0) + 1);
}

export function releaseImageRef(guid: string) {
    const next = (refMap.get(guid) ?? 0) - 1;
    if (next <= 0) {
        const url = urlMap.get(guid);
        if (url) URL.revokeObjectURL(url);
        refMap.delete(guid);
        urlMap.delete(guid);
        blobMap.delete(guid);
    } else {
        refMap.set(guid, next);
    }
}

export function clearAllImages() {
    for (const url of urlMap.values()) URL.revokeObjectURL(url);
    refMap.clear();
    urlMap.clear();
    blobMap.clear();
}
